var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useContext, useEffect } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { LoadingBounce, UserAvatar } from '@michelin/acid-components';
import { Divider, MenuItem, ListItemIcon, ListItemText, } from '@material-ui/core';
import { Language } from '@material-ui/icons';
import MissingTranslations from '../../compositions/MissingTranslations';
import HeaderLogoutBtn from './HeaderLogoutBtn/HeaderLogoutBtn';
import { LanguageSwitch } from './LanguageSwitch/LanguageSwitch';
import { ThemeSwitch } from './ThemeSwitch/ThemeSwitch';
import { ChangePassword } from './ChangePassword/ChangePassword';
import { useStyles } from '../../styles/profileBoxStyles';
import { ProfileMenuItem } from './ProfileMenuItem';
import i18n from '../../translations/CentralTranslation';
import { AppSwitch } from '../AppSwitch/AppSwitch';
import { CentralProviderContext } from '../../centralProviderContext/CentralProviderContext';
import { UserProfile } from './UserProfile/UserProfile';
import { WhatsNew } from './WhatsNew/WhatsNew';
import { useGetReleaseNotes } from '../../hooks/APICallsHooks/useGetReleaseNotes';
import { CopyBearerToken } from './CopyBearerToken/CopyBearerToken';
import { useGetFAQ } from '../../hooks/APICallsHooks/useGetFAQ';
import { FaqMenuItem } from './Faq/FaqMenuItem';
export function ProfileBox(_a) {
    var _b = _a.name, name = _b === void 0 ? '' : _b, _c = _a.email, email = _c === void 0 ? '' : _c, _d = _a.profileMenuItems, profileMenuItems = _d === void 0 ? [] : _d, _e = _a.userRole, userRole = _e === void 0 ? '' : _e, languages = _a.languages, onNavigate = _a.onNavigate, showAppMenu = _a.showAppMenu;
    var _f = __read(React.useState(null), 2), anchorEl = _f[0], setAnchorEl = _f[1];
    var _g = __read(React.useState(false), 2), shiftKey = _g[0], setShiftKey = _g[1];
    var _h = useContext(CentralProviderContext), application = _h.application, currentLanguage = _h.currentLanguage;
    var classes = useStyles();
    var theme = useTheme();
    var _j = useGetReleaseNotes(application, currentLanguage), searchReleaseNotes = _j.refetch, releaseNotesData = _j.data, releaseNotesLoading = _j.isLoading;
    var _k = useGetFAQ(application, currentLanguage), searchFAQs = _k.refetch, faqData = _k.data, faqLoading = _k.isLoading;
    if (currentLanguage && i18n.language !== currentLanguage) {
        i18n.changeLanguage(currentLanguage);
    }
    useEffect(function () {
        // Searching faq and release notes in case the language changes and the menu is open
        if (anchorEl) {
            searchFAQs();
            searchReleaseNotes();
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [currentLanguage]);
    function onMenuOpen(event) {
        if (!faqData) {
            searchFAQs();
        }
        if (!releaseNotesData) {
            searchReleaseNotes();
        }
        setShiftKey(event.shiftKey);
        setAnchorEl(event.currentTarget);
    }
    function closeDropdown() {
        setAnchorEl(null);
    }
    return (React.createElement(UserAvatar, { name: name, email: email, description: userRole, color: "primary", className: classes.container, avatarOnly: true, anchorEl: anchorEl, onClick: onMenuOpen, closeMenu: closeDropdown },
        React.createElement("div", { className: classes.info },
            React.createElement("span", { className: classes.name }, name),
            React.createElement("span", { className: classes.email }, email)),
        React.createElement(Divider, null),
        profileMenuItems.map(function (menuItem) { return (React.createElement(ProfileMenuItem, __assign({ key: "".concat(menuItem.label) }, menuItem, { closeDropdown: closeDropdown }))); }),
        showAppMenu && (React.createElement(AppSwitch, null)),
        React.createElement(UserProfile, { closeDropdown: closeDropdown }),
        languages && languages.length > 1
            ? (React.createElement(MenuItem, null,
                React.createElement(ListItemIcon, { style: { minWidth: '33px' } },
                    React.createElement(Language, { color: "primary" })),
                React.createElement(ListItemText, null,
                    React.createElement(LanguageSwitch, { onChange: onNavigate, languages: languages }))))
            : null,
        React.createElement(ChangePassword, { closeDropdown: closeDropdown }),
        shiftKey && React.createElement(CopyBearerToken, { closeDropdown: closeDropdown }),
        React.createElement(ThemeSwitch, null),
        releaseNotesLoading ? React.createElement(LoadingBounce, { size: "1vh", color: theme.palette.common.white }) : React.createElement(WhatsNew, { releaseNotes: releaseNotesData === null || releaseNotesData === void 0 ? void 0 : releaseNotesData.data }),
        faqLoading ? React.createElement(LoadingBounce, { size: "1vh", color: theme.palette.common.white }) : React.createElement(FaqMenuItem, { faqs: faqData === null || faqData === void 0 ? void 0 : faqData.data }),
        React.createElement(Divider, null),
        React.createElement(MissingTranslations, null),
        React.createElement(HeaderLogoutBtn, null)));
}
//# sourceMappingURL=ProfileBox.js.map